import React from "react";
import HeaderSection from "../../components/header";
import CommonHeroSection from "../../components/CommonHeroSection/CommonHeroSection";
import image2 from "../../assets/serviceBg.png";
import ChimneySweepSection from "./ChimneySweepSection";
import TestimonialSection2 from "../../components/TestimonialSection2";
import serviceman from '../../assets/chimneySweepBg1.png'
import Footer from "../../components/footerSection";

import faqImg from '../../assets/serviceBg.png'
import ContactUsSection from "../../components/servicesSection/ContactUsSection";
import FAQsSection from "../../components/FAQsSection";
import OurGlorySection from "../../components/OurGlorySection";
import './service.css'

export default function ServicePage() {

  const ExpandDataAll = [
    {
      question: "WHY to get your chimney Swept?",
      answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
            burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
            for optimal heat and safety.`,
    },
    {
      question: "WHEN to get your Chimney Swept?",
      answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
              burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
              for optimal heat and safety.`,
    },
    {
      question: "HOW to Prepare your chimney for sweeping?",
      answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
              burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
              for optimal heat and safety.`,
    },
    {
      question: "WHAT Happens when your chimney is not cleaned?",
      answer: `You need to clean your chimney to prevent chimney fires and ensure efficient 
              burning. Soot buildup is flammable, and a clean chimney allows proper airflow 
              for optimal heat and safety.`,
    },
  ];
  return (
    <div>
      <HeaderSection />
      <CommonHeroSection
        imgName={image2}
        titleHead="Chimney Sweeping"
        extraContent={`Home > Our Services > Chimney Sweeping`}
      />
      <ChimneySweepSection
        firstSentence={`How often Do you Think you should`}
        secSentence={`Clean your Chimney`}
        thirdSentence={`?? 
      Bi-Annualy, Yes that’s right!!`}
        title={`Chimney Sweep:`}
        subTitle={`Flame it Safe!`}
        extraContent={`Don't let winter chills turn into fire safety scares! Leduc Chimney
      Sweeps Ltd. cleans all the deposited soot, ash, and debris with 
     expert cleaning using specialized tools like brushes, rods and 
     Vacuums. Our meticulous service ensures your chimney is 
     prepped for peak performance and safety next season. Breathe 
     easy and enjoy cozy winter nights with a clean and efficient 
     fireplace – contact Leduc Chimney Sweep Ltd. Today!`}
     bgImg={serviceman}

      />
      <FAQsSection
        firstSentence={`Don't Let Smoke Cloud Your Fun! `}
        secSentence={`Leduc Chimney`}
        thirdSentence={` Sweep - Breathe Easy This Winter.`}
        ExpandDataAll={ExpandDataAll}
        faqImg={faqImg}
      />
      <OurGlorySection/>
      <ContactUsSection />

      <Footer />
    </div>
  );
}
